@use "../../../globals/settings";
@use "../../../globals/bcp-2022/common/supergraphic";
@use "../../../globals/bcp";
@use "../../../globals/libs/hy.core.css/layout/page-row";
//TT CUSTOMS START
@use "../../../globals/bcptools/tools/color-schemes";
//TT CUSTOMS END

$self: ".o-header";
$logo-width: 162px;

:host {
  display: block;
}

.l-page-row {
  @include page-row.page-row;
}

.o-header {
  @include supergraphic.generate();

  &__top {
    display: flex;
    align-items: center;
    min-height: 96px;
    padding-top: bcp.n(2);
    padding-bottom: bcp.n(2);
    box-sizing: border-box;

    @include bcp.respond-lte(tabletp) {
      padding-top: 0;
      padding-bottom: 0;
      min-height: 48px;
    }
  }

  &__logo-container {
    ::slotted(f-logo) {
      width: 144px;

      @include bcp.respond-lte(tabletp) {
        width: 108px;
      }
    }
  }

  &__quicklinks-container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__search-container {
    display: flex;
    align-items: center;
  }

  &__mid {
    display: flex;
    align-items: center;
  }

  &__navigation-container {
    flex-grow: 1;
  }

  &__subbrand {
    margin: 0;
    font-weight: bcp.$font-weight-bold;
  }

  &__bottom {
    display: flex;
    align-items: center;
  }

  &__breadcrumbs-container {
    flex-grow: 1;
    padding-top: bcp.n(2, settings.$rel-unit);
    padding-bottom: bcp.n(2, settings.$rel-unit);

    @include bcp.respond-lte(tabletp) {
      display: none;
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
/* stylelint-disable no-duplicate-selectors */
@include bcp.theme("ivt") {
  .o-header {
    padding-top: 0;

    &::before {
      content: none;
    }

    &__top-container {
      @include color-schemes.generate("light-contrast");
    }

    &__mid-container {
      padding-top: bcp.n(4);
      padding-bottom: bcp.n(4);

      @include color-schemes.generate("light-secondary");
    }
  }
}

@include bcp.theme("buderus") {
  .o-header {
    padding-top: 0;

    &::before {
      content: none;
    }

    &__logo-container {
      @include bcp.respond-lte(tabletp) {
        ::slotted(f-logo) {
          width: 50px;
        }
      }
    }

    &__top {
      &-container {
        @include color-schemes.generate("light-contrast");
      }
    }

    &__mid {
      &-container {
        @include color-schemes.generate("dark-primary");
      }
    }

    @include bcp.respond-gte(tabletl) {
      min-height: 162px;

      &__logo-container {
        ::slotted(f-logo) {
          width: $logo-width;
        }
      }

      &__top {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 0;
      }

      &__bottom {
        padding-left: $logo-width + bcp.n(2);
      }

      &__mid {
        padding-left: $logo-width + bcp.n(2);

        &-container {
          padding-top: bcp.n(2);
          padding-bottom: bcp.n(2);
        }
      }
    }
  }
}

@include bcp.theme("vulcano") {
  .o-header {
    padding-top: 0;

    &::before {
      background-image: none;
      background-color: bcp.colorVar("link-text");
    }
  }
}
